import { render, staticRenderFns } from "./ModalBinnacle.vue?vue&type=template&id=518862bc&"
import script from "./ModalBinnacle.vue?vue&type=script&lang=js&"
export * from "./ModalBinnacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518862bc')) {
      api.createRecord('518862bc', component.options)
    } else {
      api.reload('518862bc', component.options)
    }
    module.hot.accept("./ModalBinnacle.vue?vue&type=template&id=518862bc&", function () {
      api.rerender('518862bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/binnacles/ModalBinnacle.vue"
export default component.exports